module.exports = __webpack_public_path__ + "img/aulus.5a8fc6ee.jpeg";